export const DEFAULT_SALES_RUBRIC = [
  {
    category: "Outcomes & Impact",
    items: [
      {
        id: "discovery",
        label: "Pre-Sale Responsibility & Discovery",
        signals: [
          "Asked open-ended questions to find root cause",
          "Did not overpromise deliverables",
          "Verified marketing budget"
        ]
      },
      {
        id: "product_knowledge",
        label: "Product & Technical Knowledge",
        signals: [
          "Explained concepts simply",
          "Provided accurate platform facts"
        ]
      },
      {
        id: "value_pitch",
        label: 'The Value Pitch & "Wow" Factor',
        signals: [
          "Tailored the solution to pain points",
          "Created genuine urgency"
        ]
      },
      {
        id: "objection_handling",
        label: "Objection Handling",
        signals: [
          "Acknowledged objection with empathy",
          "Used logical comparisons to overcome"
        ]
      },
      {
        id: "closing",
        label: "Closing Techniques",
        signals: [
          "Assumed the sale and asked for business",
          "Summarized key takeaways"
        ]
      }
    ]
  },
  {
    category: "Relationship & Trust",
    items: [
      {
        id: "call_flow",
        label: "Call Flow & Agenda Setting",
        signals: [
          "Stated clear agenda in first 60s",
          "Displayed authority and control"
        ]
      },
      {
        id: "active_listening",
        label: "Active Listening",
        signals: [
          "Did not interrupt the prospect",
          "Repeated key pain points back to prospect"
        ]
      }
    ]
  },
  {
    category: "Compliance & Risk",
    items: [
      {
        id: "compliance",
        label: "Mandatory Compliance",
        signals: [
          "Stated that call is being recorded",
          "Did not make guaranteeing statements (e.g. 'I promise page 1')"
        ]
      }
    ]
  }
];
